import React, { useState } from 'react';
// Api
import client from '../../api/client';
// Components
import LoadingSpinner from '../utils/LoadingSpinner';
// Constants
import { RESET_PASSWORD_API } from '../../utils/ApiRoutes';

function ForgotPasswordForm() {
  const [resetRequestInProgress, setResetRequestInProgress] = useState(false);
  const [resetRequestError, setResetRequestError] = useState(false);
  const [resetRequestSuccess, setResetRequestSuccess] = useState(false); // New state for success message
  const [resetFormData, setResetFormData] = useState({
    email: '',
  });

  const handleResetRequest = (event) => {
    event.preventDefault();
    setResetRequestInProgress(true);
    setResetRequestError(false);
    setResetRequestSuccess(false); // Reset success message on new request

    client
      .post(RESET_PASSWORD_API, resetFormData, false)
      .then((res) => {
        setResetRequestInProgress(false);
        setResetRequestSuccess(true); // Show success message on success
      })
      .catch((err) => {
        setResetRequestError(true);
        setResetRequestInProgress(false);
        console.error('Unable to request password reset', err);
      });
  };

  const handleChange = (event) => {
    setResetRequestError(false);
    setResetRequestSuccess(false); // Reset success message on new input
    const { name, value } = event.target;

    setResetFormData({
      ...resetFormData,
      [name]: value,
    });
  };

  return (
    <form className='space-y-4 md:space-y-6' onSubmit={handleResetRequest}>
      <div>
        <label
          htmlFor='email'
          className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'
        >
          Your email:
        </label>
        <input
          type='email'
          name='email'
          id='email'
          className='w-full p-2 mt-1 bg-colour7 dark:bg-colour7 rounded'
          placeholder='name@email.com'
          onChange={handleChange}
          required
          aria-invalid={resetRequestError ? 'true' : 'false'}
          aria-describedby={resetRequestError ? 'email-error' : undefined}
        />
      </div>

      <div>
        <button
          type='submit'
          className={`inline-block px-6 py-2.5 w-full bg-colour4 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:brightness-110 hover:shadow-lg focus:bg-colour4 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-colour4 active:shadow-lg transition duration-150 ease-in-out`}
          aria-label='Request a password reset'
          disabled={resetRequestInProgress}
        >
          {resetRequestInProgress ? (
            <LoadingSpinner xs={true} />
          ) : (
            <span>Reset Password</span>
          )}
        </button>
      </div>

      {resetRequestError && (
        <div role='alert' aria-live='assertive' className='text-error-red'>
          Unable to request password reset. Please try again.
        </div>
      )}

      {resetRequestSuccess && (
        <div role='alert' aria-live='polite' className='text-green-600'>
          Password reset link has been sent to your email.
        </div>
      )}
    </form>
  );
}

export default ForgotPasswordForm;
